import {BrukerModell, DokumentSignatarerModell, DokumentSignatarModell, DokumentTilSigneringModell, PotensiellDokumentSignatarModell} from "../tjenester/ressurser/generertNg2HttpKlient";

export function signatarerSomIkkeHarSignert(signatarer: DokumentSignatarerModell): DokumentSignatarModell[] {
    return signatarer.signatarer.filter(signatar => !signatar.harSignert);
}

export function signatarerSomHarSignert(signatarer: DokumentSignatarerModell): DokumentSignatarModell[] {
    return signatarer.signatarer.filter(deltaker => deltaker.harSignert);
}

/** Returnerer dokumenter som skal signeres av minst én annen enn angitt bruker, og der vedkommende enda ikke har signert. */
export function dokumenterSomSkalSigneresAvAndreEnn<T>(dokumenterTilSignering: DokumentTilSigneringModell<T>[], bruker: BrukerModell): DokumentTilSigneringModell<T>[] {
    return dokumenterTilSignering.filter(dokument => dokument.signatarer.signatarer
      .some(signatar => signatar.medlem.brukerId !== bruker.id && !signatar.harSignert));
}

export function potensiellDokumentSignatarSomIkkeSkalSignere(): PotensiellDokumentSignatarModell {
    return {signatar: null, signatarFunnet: false, antattStoettedeSigneringsmetoder: []} as PotensiellDokumentSignatarModell;
}
